import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import Caption from '@polestar/component-warehouse-react/components/caption/Caption';
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
const GalleryCaption = forwardRef(({ activeIndex, captions, hideIndicator, length, ...props }, ref) => {
    const { isRTL } = useDirection();
    const currentIndex = ('00' + (activeIndex + 1)).slice(-2);
    const total = ('00' + length).slice(-2);
    // Check if all captions are empty
    const filteredCaptions = captions.filter(Boolean);
    const hasCaptions = filteredCaptions.length > 0;
    return (React.createElement(GalleryCaptionWrapper, { ref: ref, ...props },
        length > 1 && !hideIndicator && (React.createElement(CurrentPage, { hasCaptions: hasCaptions }, isRTL ? `${total}/${currentIndex}` : `${currentIndex}/${total}`)),
        hasCaptions && (React.createElement(Captions, null, captions.map((caption, index) => {
            const active = index === activeIndex;
            return (!!caption && (React.createElement(CaptionWrapper, { active: active, "aria-hidden": !active, key: index },
                React.createElement(CaptionText, null, caption))));
        })))));
});
GalleryCaption.displayName = 'GalleryCaption';
export default GalleryCaption;
const Captions = styled.div `
  display: grid;

  > * {
    grid-area: 1 / 1;
  }
`;
const CurrentPage = styled(Paragraph)(({ hasCaptions, theme }) => css `
    width: ${Spacings.xxLarge};
    min-width: ${Spacings.xLarge};
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
    color: ${hasCaptions ? theme.gallery.captions.countColor : theme.gallery.captions.captionColor};
  `);
const CaptionWrapper = styled.div(({ active }) => active
    ? css `
        visibility: visible;
        pointer-events: auto;
        user-select: text;
      `
    : css `
        visibility: hidden;
        pointer-events: none;
        user-select: none;
      `);
const CaptionText = styled(Caption)(({ theme }) => css `
    color: ${theme.gallery.captions.captionColor};
  `);
const GalleryCaptionWrapper = styled.div `
  position: relative;
  display: flex;
  gap: ${Spacings.xxSmall};
  width: 100%;
  padding-block-start: ${Spacings.small};
`;
